const style = {
  email: {
    fontSize: `12px`
  },
  name: {
    color: `black`
  },
  groupCount: {
    fontSize: `13px`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserTable/style/user.js